export default __webpack_public_path__ + "4346795f9ef9c2890de6b5a0ad691c64.png";